import { render, staticRenderFns } from "./SelectionOtherPK.vue?vue&type=template&id=10b057ec&"
import script from "./SelectionOtherPK.vue?vue&type=script&lang=js&"
export * from "./SelectionOtherPK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports